import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './index';
export const StoreProvider = ({ children, loading = null }) => {
    return (_jsx(Provider, { store: store, children: _jsx(PersistGate, { loading: loading, persistor: persistor, children: children }) }));
};
export default StoreProvider;
